import { render } from "./Admin.vue?vue&type=template&id=4706df70&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=4706df70&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/shamudeen/shamudeen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4706df70"]])

export default __exports__